/**
 * Stato mail fornitore derivato dal raw dell'Order — nucleo condiviso AS/WF.
 *
 * Fra i due fornitori cambiano SOLO il prefisso dei campi raw e il
 * destinatario: tenerne due copie aveva gia' fatto divergere la forma della
 * catena di stati (equivalente, ma scritta diversa) ed e' il primo passo
 * perche' diverga anche il comportamento.
 *
 * Speculare a ``mail_status_snapshot(prefix, channel, recipient)`` del
 * backend (modules/suppliers/service.py), ramo di fallback su ``Order.raw``.
 *
 * Il pickup Ita/Ity NON passa di qui: legge campi di dominio diversi
 * (``ldv_mail_*``) e ha una catena a due stati — vedi ``pickupMailApi.ts``.
 */

import type { AllServiceMailStatusDetail, AllServiceMailStatusState } from "./allserviceApi";

export function deriveSupplierMailStatusFromRaw(
  raw: Record<string, unknown> | null | undefined,
  opts: { prefix: string; recipient: string },
): AllServiceMailStatusDetail {
  const r = raw ?? {};
  const str = (key: string): string | null => {
    const value = r[`${opts.prefix}_${key}`];
    return typeof value === "string" ? value : null;
  };

  const appSent = str("mail_app_sent_at");
  const imapConfirmed = str("mail_imap_confirmed_at");
  const legacyConfirmed = str("mail_inviata_il");
  const attempts = r[`${opts.prefix}_mail_app_attempts`];
  const inviata = Boolean(r[`${opts.prefix}_mail_inviata`]);

  let state: AllServiceMailStatusState;
  if (inviata && imapConfirmed) state = "confirmed_imap";
  else if (appSent && !imapConfirmed) state = "pending_imap";
  else if (inviata && (imapConfirmed || legacyConfirmed)) state = "confirmed_imap";
  else state = "never_sent";

  return {
    state,
    app_sent_at: appSent,
    app_message_id: str("mail_app_message_id"),
    app_attachment: str("mail_app_attachment"),
    app_attempts: typeof attempts === "number" ? attempts : 0,
    imap_confirmed_at: imapConfirmed ?? (state === "confirmed_imap" ? legacyConfirmed : null),
    imap_message_id: str("mail_message_id") ?? "",
    imap_attachment: str("mail_attachment") ?? "",
    recipient: opts.recipient,
  };
}
